import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const DEFAULT_STORE_HOURS = [
  { day: 'Monday', open: '07:30', close: '17:00', closed: false },
  { day: 'Tuesday', open: '07:30', close: '17:00', closed: false },
  { day: 'Wednesday', open: '07:30', close: '17:00', closed: false },
  { day: 'Thursday', open: '07:30', close: '17:00', closed: false },
  { day: 'Friday', open: '07:30', close: '17:00', closed: false },
  { day: 'Saturday', open: '', close: '', closed: true },
  { day: 'Sunday', open: '', close: '', closed: true },
  { day: 'Stat Holidays', open: '', close: '', closed: true },
];

function formatStoreTime(time) {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  const hour = Number(hours);
  return `${hour % 12 || 12}:${minutes} ${hour >= 12 ? 'PM' : 'AM'}`;
}

const HERO_SLIDES = [
  '/assets/image/revival1.png',
  '/assets/image/revival2.png',
  '/assets/image/revival3.png',
  '/assets/image/revival4.png',
  '/assets/image/revival5.png',
];

const pageStyles = ".main-content .slider-bg {\n        color: #0a1203;\n        font-weight: bold;\n        background-color: #64a57b57;\n        backdrop-filter: blur(4px);\n        opacity: 0;\n        -webkit-transform: translateY(100px);\n        -moz-transform: translateY(100px);\n        -ms-transform: translateY(100px);\n        -o-transform: translateY(100px);\n        --webkit-transition: all 1000ms ease;\n        -moz-transition: all 100ms ease;\n        -ms-transition: all 1000ms ease;\n        -o-transition: all 1000ms ease;\n        transition: all 1000ms ease;\n    }\n\n    .main-slider .slide {\n        padding: 0;\n    }\n\n    .main-content .active .slider-bg {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transition-delay: 1700ms;\n    }\n\n    .full-height {\n        height: 100%;\n        width: 100%;\n        padding: 100px 0 100px;\n        -webkit-backdrop-filter: blur(7px);\n        backdrop-filter: blur(7px);\n    }";

export default function HomePage() {
  const [storeHours, setStoreHours] = useState(DEFAULT_STORE_HOURS);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    api.publicSettings()
      .then((settings) => {
        if (settings.storeHours?.length) setStoreHours(settings.storeHours);
      })
      .catch(() => {
        // Keep the default hours visible if the public settings request is unavailable.
      });
  }, []);
  return (
    <>
      <style>{pageStyles}</style>
      <section className="main-slider" id="revivalHome">

          <div className="main-slider-carousel main-slider-one owl-carousel owl-theme">
                  {HERO_SLIDES.map((src) => (
                    <div className="slide" key={src}>
                      <img className="slide-image" src={src} alt="Revival Pharmacy" />
                      <div className="container text-center full-height">
                          <div className="content ">
                              <h1 className="btn btn-dark" style={{color: "white"}}>
                                  GIVING PATIENTS<br />
                                  <span className="text-success">THE CARE THEY DESERVE</span>
                              </h1>

                              <div className="link-box">
                                  <a href="/Home/Contact" className="theme-btn ">Services</a>
                                  <a href="/Home/Info" className="theme-btn btn-dark">get in touch</a>
                              </div>
                          </div>
                      </div>
                    </div>
                  ))}
          </div>

      </section>
      {/*----main-slider----*/}
      {/*-----appointment-section---*/}
      <section className="appointment_section hm-one">
          <div className="container">
              <div className="appointment_inner">
                  <div className="row">
                      <div className="col-lg-5 col-md-5 col-sm-12">
                          <div className="appont_sec_inner">
                              <h5 className="alert-success p-2">
                                  Contact Us
                              </h5>

                              <span className="fa fa-phone">&emsp;(306) 559-3228</span> <br />
                              <span className="fa fa-phone">&emsp;(306) 559-3428</span> <br />
                              <span className="fa fa-fax">&emsp;(306) 205-2381</span> <br /><br />
      <p className="text-justify">Discover Revival Pharmacy, located at the core of Regina, Canada, devoted to delivering unparalleled care and bespoke services to our local community. Guided by our dedication to well-being and accessibility, we endeavor to invigorate your path towards better health through professional expertise and genuine empathy.</p>
                              <br />
                              <span className="fa fa-envelope">&emsp;bhavya@revivalpharmacy.ca</span>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                          <div className="appont_sec_inner">
                              <h5 className="alert-success p-2">
                                  Store Hours
                              </h5>
                              <ul>
                                  {storeHours.map((hour) => (
                                    <li key={hour.day}>
                                      {hour.day}
                                      <span className={`float-right${hour.closed ? ' text-danger' : ''}`}>
                                        {hour.closed
                                          ? 'CLOSED'
                                          : `${formatStoreTime(hour.open)} - ${formatStoreTime(hour.close)}`}
                                      </span>
                                    </li>
                                  ))}
                              </ul>
                          </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                          <div className="appont_sec_inner">


                              <img src="/assets/image/r4.jpeg" style={{height: "100%"}} alt="Alternate Text" />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      {/*-----appointment-section---*/}
      {/*-----appointment-section---*/}

      <section className="department_section hm-one">
          <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                      <div className="heading clearfix">
                          <h1>Services Available at<span> Revival Pharmacy</span></h1>
                      </div>
                  </div>
              </div>
              <div className="department_inner">
                  <div className="row">
                      <div className="col-lg-12">
                          <div className="department_icon_content">
                              <a><span className="flaticon-heart-1 dep_icon"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#healthManagement"><h6>Health Management</h6></a>
                              <div id="healthManagement" className="collapse show">
                                  <p>Consult our expert pharmacists for personalized guidance on managing health conditions like acne, athletes’ foot, hemorrhoids, oral thrush, and seasonal allergies.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a><span className="flaticon-calendar dep_icon"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#medicationAssessments"><h6>Medication Assessments</h6></a>
                              <div id="medicationAssessments" className="collapse">
                                  <p>Optimize your medication regimen with comprehensive assessments by our pharmacists, covering prescriptions, over-the-counter drugs, supplements, and vitamins.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a><span className="flaticon-doctor dep_icon"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#medicationOrganization"><h6>Medication Organization</h6></a>
                              <div id="medicationOrganization" className="collapse">
                                  <p>Enhance medication management with guidance from our pharmacists, including options like blister packs, ensuring safe and convenient dosing.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a><span className="flaticon-doctor-1 dep_icon"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#medicationTakeBack"><h6>Medication Take Back</h6></a>
                              <div id="medicationTakeBack" className="collapse">
                                  <p>Dispose of unused or expired medications, as well as syringes, lancets, and pen needles, responsibly at Revival Pharmacy.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a><span className="flaticon-drug dep_icon"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#prescriptionRefills"><h6>Prescription Refills</h6></a>
                              <div id="prescriptionRefills" className="collapse">
                                  <p>Streamline your prescription refills with Revival Pharmacy, offering convenient ordering options tailored to your needs.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a data-toggle="collapse" data-target="#prescriptionRenewals"><span className="flaticon-time"></span><h6>Prescription Renewals</h6></a>
                              <div id="prescriptionRenewals" className="collapse">
                                  <p>Ensure uninterrupted medication supply with prescription renewals facilitated by our dedicated team at Revival Pharmacy.</p>
                              </div>
                          </div>
                          <div className="department_icon_content">
                              <a><span className="flaticon-supermarket"></span></a>
                              <a href="#" data-toggle="collapse" data-target="#prescriptionTransfers"><h6>Prescription Transfers</h6></a>
                              <div id="prescriptionTransfers" className="collapse">
                                  <p>Transfer your prescriptions seamlessly to Revival Pharmacy for expert guidance and continued care from our experienced pharmacists.</p>
                              </div>
                          </div>
                      </div>


                  </div>
              </div>
          </div>
      </section>




      {/*-------welcomen-sec-------*/}
      <section className="welcome_section hme-one" style={{background: "url('/assets/image/Smiling%20Pharmacist%20in%20a%20Bright%20Clinic.png')"}}>
          <div className="container">

              <div className="row">
                  <div className="col-lg-6">
                      <div className="welcme_inner">
                          <div className="heading clearfix">
                              <h1>Welcome to <span>Revival Pharmacy</span></h1>
                          </div>
                          <h6>Your Trusted Healthcare Partner in Regina</h6>
                          <p>At Revival Pharmacy, we're dedicated to providing top-notch healthcare services tailored to your needs. With personalized care and quality services, we're committed to your well-being every step of the way.</p>
                          <p>Our goal is simple: to be there for you when you need us. Whether it's medication management or wellness advice, trust Revival Pharmacy to support your health journey.</p>
                      </div>

                  </div>
                  <div className="col-lg-6">
                  </div>
              </div>
          </div>
      </section>
      {/*-------welcomen-sec-------*/}
      {/*-----appointment-section---*/}
      <section className="testimonial_sec hm-one">
          <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                      <div className="heading clearfix">
                          <h1>WHAT <span>CLIENTS SAY</span></h1>
                      </div>
                  </div>
              </div>
              <div className="owl-carousel owl-theme two-item">
                  <div className="testimonial_content">
                      <p>"EVERY PHARMACY SHOULD HAVE ONE OF HER! best accommodating, caring individual along with the other staff members! Thank you for your extra efforts and assistance the pharmacy continuously provides with out skipping a beat!"</p>
                      <div className="client_details">
                          <img src="/assets/image/user.png" height="25" className="img-fluid" alt="test" />
                          <div className="client_in">
                              <h6>Brent MacLeod</h6>
                              <span>Customer</span>
                          </div>
                      </div>
                  </div>
                  <div className="testimonial_content">
                      <p>"One of the best pharmacies in the city.I highly recommend this place for fast , friendly and reliable service to the clients.  Bhavya and Harry go above and beyond to meet all your pharmacy requirements."</p>
                      <div className="client_details">
                          <img src="/assets/image/user.png" height="25" className="img-fluid" alt="test" />
                          <div className="client_in">
                              <h6>Tina Sayer</h6>
                              <span>Local Guide</span>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
      </section>
      <section className="map-section">
          <div className="container">
              {/*Map Outer*/}
              <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10">
                      {/*Map Section*/}
                      <div className="embed-responsive embed-responsive-16by9">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10159.907093700662!2d-104.6183373!3d50.4601572!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x531c1f7473f9e205%3A0x4d128b1d29f2a376!2sREVIVAL%20PHARMACY!5e0!3m2!1sen!2sin!4v1712379169822!5m2!1sen!2sin" className="embed-responsive-item" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                  </div>
              </div>
          </div>
      </section>


      {/*End Map Section*/}
      {/*-----contact-through---*/}
    </>
  );
}
